<template>
  <div class="line-chart-wrapper">
    <div ref="chart" v-show="!empty" class="line-chart-wrapper-canvas"></div>
    <Empty v-show="empty" />
  </div>
</template>

<script>
import { Chart } from '@antv/g2';
import { pxtorem } from '@/libs/fontfit';
import { cloneDeep } from 'lodash';

export default {
  props: {
    // 源数据
    dataSource: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 0,
    },
    empty: {
      type: Boolean,
      default: false,
    },
    colorList: {
      type: Array,
      // default: ['#165DFF', '#50CD89', '#F7BA1E', '#FF7C7C', '#9B9B9B'],
      default: () => [],
    },
    legend: {
      type: Boolean,
      default: false,
    },
    // 小数位
    decimal: {
      type: Number,
      default: 2,
    },
    xField: {
      type: String,
      default: 'date',
    },
    yField: {
      type: String,
      default: 'value',
    },
    xLabelFormatter: {
      type: Function,
      default: v => v,
    },

    // 格式化值
    formatValue: {
      type: [Function, String],
      default: '',
    },
  },
  computed: {
    data() {
      // 使用 slice() 创建副本，避免直接修改 props
      return cloneDeep(this.dataSource);
    },
  },

  watch: {
    data(value) {
      if (value) {
        // 数据更新时调用，因为是API请求
        this.createChart();
      }
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    if (this.$refs.chart) {
      this.createChart();
    }
  },
  methods: {
    createChart() {
      const data = this.data || [];

      // 销毁
      if (this.chart) {
        this.chart.destroy();
      }

      const params = {
        container: this.$refs.chart,
        autoFit: true,
      };

      if (this.height) {
        params.height = pxtorem(this.height);
      }

      if (this.width) {
        params.width = pxtorem(this.width);
      }

      this.chart = new Chart(params);

      this.chart
        .data(data)
        .encode('x', this.xField)
        .encode('y', this.yField)
        .scale('x', {
          range: [0, 1],
        })
        .scale('y', {
          domainMin: 0,
          nice: true,
        })
        .scale('x', {
          range: [0.01, 1],
        });

      this.chart.line();

      // 格式化x
      this.chart
        .axis('x', {
          title: false,
          labelFormatter: this.xLabelFormatter,
          labelAutoRotate: false, // 禁止自动旋转
        })
        .axis('y', {
          title: false,
          labelFormatter: v => {
            if (this.formatValue) {
              return this.formatValue(v);
            }
            return v;
          },
        });

      this.chart
        .interaction('tooltip', {
          shared: true,
          // render 回调方法返回一个innerHTML 或者 DOM
          render: (event, { title, items }) => {
            let itemHtml = '';
            items.reverse().forEach(d => {
              itemHtml += `<li style="list-style-type: disc;margin-left:10px;color:${d.color};">
              <span style="color: ${d.color};padding-right:20px;">${d.name}</span>
              <span style="color:#000">${
                this.formatValue ? this.formatValue(d.value) : d.value
              } </span>
              </li>`;
            });

            return `<div>
            <h3 style="padding:0;margin:0 0 5px 0;">${this.xLabelFormatter(title)}</h3>
            <ul>${itemHtml}</ul>
            </div>`;
          },
        })
        .interaction('elementHighlightByColor', {
          background: true,
          highlight: true,
          color: '#000',
        });

      // 点
      this.chart
        .point()
        .style('fill', 'white')
        .tooltip(false);

      this.chart.render();
    },
  },
};
</script>
<style lang="less" scoped>
.line-chart-wrapper {
  width: 100%;
  height: 100%;

  .line-chart-wrapper-canvas {
    width: 100%;
    height: 100%;

    canvas {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>
